import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=9c0fd3e6&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=9c0fd3e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0fd3e6",
  null
  
)

export default component.exports